export const AuthenticationType = {
	ApiKey: "ApiKey",
	BasicAuth: "BasicAuth",
	Hmac: "Hmac",
	None: "None",
	OAuth: "OAuth",
} as const;
